import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"add\">\r\n    <path d=\"M14 27V16H3v-2h11V3h2v11h11v2H16v11z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol